<template>
  <div class="ivan-setting-page anCore-fill" v-loading="loading">
    <div class="row">
      <div class="form-group col-sm-4 has-feedback">
        <div class="input-group">
          <span class="input-group-addon"><span>方法依据</span></span>
          <input class="form-control" v-model="keyWord" @input="resetPage">
          <span class="fa fa-search form-control-feedback" aria-hidden="true" />
          <span class="sr-only">-</span>
        </div>
      </div>
    </div>

    <div class="table-area">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="min-width:88px;">方法名称</th>
            <th style="min-width:88px;">依据编号</th>
            <th style="min-width:120px;">适用项目类型</th>
            <th style="min-width:150px;">适用场景</th>
            <th style="min-width:110px;">启用日期</th>
            <th style="min-width:110px;">停用日期</th>
            <th style="min-width:88px;">当前状态</th>
            <th style="min-width:88px;">备注</th>
            <th style="width:110px;text-align:center;">
              <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                <i class="fa fa-plus" />&nbsp;新增
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-if="pageRows.length">
          <tr
            v-for="row in pageRows"
            :key="row.MethodID"
            :class="{ 'anCore-item-active': selectedId === row.MethodID }"
            @click="selectRow(row.MethodID)"
          >
            <td>{{ row.MethodName }}</td>
            <td><span>{{ row.AccordName }}</span></td>
            <td>{{ row.InspectBasicType }}</td>
            <td>
              <span v-if="row.IsUseForPick" style="display:inline-block;margin-right:20px;">现场监测</span>
              <span v-if="row.IsUseForLab">实验室分析</span>
            </td>
            <td><span>{{ formatDate(row.LaunchDate) }}</span></td>
            <td><span>{{ formatDate(row.OutageDate) }}</span></td>
            <td><span>{{ stateText(row.StateFlag) }}</span></td>
            <td>{{ row.Remark || '' }}</td>
            <td>
              <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                <i class="fa fa-edit" />
              </button>
              <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
      <ivan-pager :page-index.sync="pageIndex" :page-count="pageCount" @change="selectedId = null" />
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'
import ivanSettingList from '@/mixins/ivanSettingList'
import IvanPager from '@/components/ivan/IvanPager.vue'

const PAGE_SIZE = 20

export default {
  name: 'MethodAccordSetting',
  components: { IvanPager },
  mixins: [ivanSettingList],
  data() {
    return {
      loading: false,
      list: [],
      keyWord: ''
    }
  },
  computed: {
    filtered() {
      const kw = String(this.keyWord || '').trim().toLowerCase()
      if (!kw) return this.list
      return this.list.filter(row => {
        const hay = [row.MethodName, row.AccordName, row.InspectBasicType, row.Remark]
          .map(x => String(x || '').toLowerCase())
          .join(' ')
        return hay.indexOf(kw) >= 0
      })
    },
    pageCount() {
      return this.calcPageCount(this.filtered.length, PAGE_SIZE)
    },
    pageRows() {
      return this.pageSlice(this.filtered, PAGE_SIZE)
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatDate(v) {
      if (!v) return ''
      const s = String(v)
      return s.length >= 10 ? s.slice(0, 10) : s
    },
    stateText(flag) {
      if (flag === 1 || flag === '1') return '正常生效'
      if (flag === -1 || flag === '-1') return '过期停用'
      return ''
    },
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('method_accord.json')
        this.list = (data && data.dataGrid && data.dataGrid.List) || []
      } catch (e) {
        this.$message.error(e.message || '加载方法依据失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivan-setting-page {
  height: 100%;
  padding: 8px 12px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ivan-setting-page > .row { margin: 0; flex: 0 0 auto; }
.table-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  height: calc(100% - 60px);
}
.table-area >>> tbody tr { cursor: pointer; }
.has-feedback .form-control-feedback {
  pointer-events: none;
  z-index: 3;
  right: 0;
  line-height: 34px;
  height: 34px;
}
</style>
